module.exports = __webpack_public_path__ + "img/gameTronos5.c3307079.jpg";